import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import DataTable from "../../Tables/DataTable";
import InfiniteScroll from "react-infinite-scroll-component";
import { assingClassRoomAction, deletePendingRegUsers, fetchRegistrationPending, formatRegistrationPending, resetRegistrationPendingAction, SET_REGISTRATION_PENDING_STUDENTS } from "../../../redux/actions/studentActions";
import DynamicFilters from "../../DynamicFilters";
import { fetchClassRoomsAction } from "../../../redux/actions/studentActions";
import AssingClass from "../List/assignClass";
import AgGridTable from "../../Tables/agGridTable";
import callApi from "../../../Api";
import AgGridLoader from "../../Tables/agGridLoader";
import SweetAlert from "react-bootstrap-sweetalert";

const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8
};

const PendingRegistration = (props) => {
  const dispatch = useDispatch();
  const { pendingRegStudentsList, loader,pagination,totalCount } = useSelector(
    (state) => state.student
  );
  const [selectedStudentEvent, setSelectedStudentEvent] = useState({});
  const [sideMenu, setSideMenu] = useState(true);
  const [show, setShow] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [filterLoader, setFilterLoader] = useState(false);
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);
  const [deleteShow,setDeleteShow] =useState(false);
  const onSideMenu = (value) => {
    setSideMenu(value);
  };
  
  useEffect(async() => {
    await dispatch(resetRegistrationPendingAction())
    await dispatch(fetchRegistrationPending({
      page:1,
      perPage: (pagination.perPage)
    }));
  }, [])

  const editAction = (data) => {
    console.log("Data",data)
    props.history.push(`/profilePending/${data.id}`)
  };
  const deleteAction = async (data) => {
    console.log(data)
    setSelectedStudentEvent(data);
    setDeleteShow(!deleteShow)
    
  };
  const deleteUser = async()=>{
    await dispatch(deletePendingRegUsers({
      UserId:selectedStudentEvent.User.id,
      StudentId: selectedStudentEvent.id
    },pendingRegStudentsList))
    setDeleteShow(false);
  }
  const onCancel = ()=>{
    setDeleteShow(false);
  }
  const assignClass = async (data) => {
    await dispatch(
      fetchClassRoomsAction({
        BranchClassGroupId: data.BranchClassGroupId,
      })
    );
    setSelectedStudentEvent(data);
    setShow(!show);
  };
  const headerList = [

    {
      name: "Name",
      key: "name",
    },
    {
      name: "Enrollment No",
      key: "RegNo",
    },
    // { name: "Gender", key: "gender" },
    { name: "Email", key: "email" },
    { name: "Mobile Number", key: "phoneNumber" },
    { name: "Guardians", key: "Guardians",requiredActions: [
      {
        name:"Father",
        dataKey: "father_name",
      },{
        name :"Father",
        dataKey:"father_phone"
      },
      {
        name:"Mother",
        dataKey: "mother_name",
      },{
        name :"Mother",
        dataKey:"mother_phone"
      }
    ] },
    { name: "Class Group", key: "ClassGroupName" },
      {
      name: "Action",
      key: "action",
      requiredActions: [
        // {
        //   actionKey: "Assign Class",
        //   icon: "fa fa-plus-circle",
        //   handleAction: assignClass,
        // },
        {
          actionKey: "Delete",
          icon: "fa fa-trash",
          handleAction: deleteAction,
        },
        {
          actionKey: "Update Profile Details",
          icon: "fa fa-pencil",
          handleAction: editAction,
        },
      ],
    },
   
  ];
  
  const actionsListComponent = props => {
    return (
        <>
            
            <i class={"fa fa-pencil"}  aria-hidden="true" title="Edit Student" style={{
          alignItems: "center",
          color: "#1c5983",
          cursor: 'pointer',
          fontSize:"18px"
          
        }} onClick={()=>{
          props.editAction(props.data);
        }}></i> &nbsp;&nbsp;&nbsp;
         <i class={"fa fa-trash" } aria-hidden="true" title="Delete Student" style={{
          alignItems: "center",
          cursor: 'pointer',
          fontSize:"18px",
          color: "#1c5983",
        }} onClick={()=>{
          props.deleteAction(props.data);
        }} ></i>
          
        
      </>
    )  
  };
  const columnDefs = [
    // {
    //   headerName: "Reg No",
    //   field: "RegNo",
    //   cellRenderer: AgGridLoader,
    //   sortable: true,filter:true,floatingFilter:true,
    //   // maxWidth: 100
    //   // cellClass:"vertical-middle",
    // },
    {
      headerName: "Name",
      field: "name",
      sortable: true,filter:true,floatingFilter:true,
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Email",
      field: "email",
      sortable: true,filter:true,floatingFilter:true,
      // cellClass:"vertical-middle",
    },
    // {
    //   headerName: "Mother Name",
    //   field: "mother_name",
    //   // cellClass:"vertical-middle",
    // },
    {
      headerName: "Mother Phone Number",
      field: "phoneNumber",
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Father Phone Number",
      field: "father_phone",
      // cellClass:"vertical-middle",
    },
    { headerName: "Branch Name", field: "BranchName" ,
    // cellClass:"vertical-middle",
  },
    { headerName: "Class Group", field: "ClassGroupName",
    // maxWidth: 150,
    // cellClass:"vertical-middle", 
  },
    
    { headerName: "Application Date", field: "dateOfAssign" ,
      // cellClass:"vertical-middle", 
  },
    {
      headerName: "Action",
      field: "action",
      maxWidth: 100,
      // cellClass:"vertical-middle",
      cellRenderer: "actionsListComponent",
      cellRendererParams: {
        deleteAction,
        editAction,
      },
      
    },
  ];
  

  const nestedHeaders =  ['','','','','Name','Phone Number ','Name','Phone Number','','',''];

  
  const DynamicFiltersProps = [
    {
      type: "TextField",
      placeholder: "Enter User Name",
      state: name,
      mappingKey: "name",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4",
      label: "Name",
    },
    {
      type: "TextField",
      placeholder: "Search By Email",
      state: email,
      mappingKey: "email",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4",
      label: "Email",
    },
    {
      type: "TextField",
      placeholder: "Search By Phone Number",
      state: phone,
      mappingKey: "phone",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4",
      label: "Mobile Number",
    },
    
    
  ];

  const DynamicFiltersOptions = {};

  const hierarchyLevel = [];
  const hierarchyApiCalls = [];
  const hierarchyFilterApi = "branchFilter";
  const onRefresh = () => {
    reloadData();
  };
  
  const reloadData = () => {
    setEmail('');
    setName('');
    setPhone('');
  };

  const updateState = (params) => {
    console.log("Params ", params);
    let keysLength = Object.keys(params).length;
    if (params.hasOwnProperty("email")) {
      setEmail(params[`email`]);
    }
    if (params.hasOwnProperty("name")) {
      setName(params[`name`]);
    }
    if (params.hasOwnProperty("phone")) {
      setPhone(params[`phone`]);
    }
  };

  const fetchParamsList = async()=>{
    const params = {
      name,
      email,
      phone,
      perPage: pagination.perPage
    };
    return params;
  }
  const filterData = async (params) => {
    return await dispatch(fetchRegistrationPending(params));
  };
  const openLoader = () => {
    console.log("Open loadarer");
    setFilterLoader(true);
  };
  const closeLoader = () => {
    setFilterLoader(false);
  };
  const closeModal = () => {
    setShow(false);
  };

  const assingClassRoom = async (data) => {
    const reqParams = {
      ...data,
      StudentId: selectedStudentEvent.id,
    };
    await dispatch(assingClassRoomAction(reqParams, [...pendingRegStudentsList]));
  };
  
  const fetchMoreData =async()=>{
    console.log(pagination,pendingRegStudentsList)
    if ((pagination.totalPages === 1 || (pagination.totalPages -1) === pagination.currentPage)  ) {
      setHasMore(false)
      return;
    }
    let reqParams = await fetchParamsList();
    reqParams.page = pagination.currentPage + 1 ;
    await filterData(reqParams);
    
  }
    const setGridRefData =(params)=>{
      setAgGridRef(params)
    }
    
  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader }>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          {deleteShow ? (
               <SweetAlert
               warning="warning"
               showCancel
               confirmBtnText="Continue"
               confirmBtnBsStyle="info"
               title="Are you sure?"
               onConfirm={deleteUser}
               onCancel={onCancel}
               focusCancelBtn
             >
             </SweetAlert>
   
          ): null }
         {/* <div class="row filter-block">
            <DynamicFilters
              filtersList={DynamicFiltersProps}
              options={DynamicFiltersOptions}
              hierarchyLevel={hierarchyLevel}
              hierarchyApiCalls={hierarchyApiCalls}
              hierarchyFilterApi={hierarchyFilterApi}
              openLoader={openLoader}
              closeLoader={closeLoader}
              updateParentState={updateState}
              filterData={filterData}
              onReset={onRefresh}
              // onDatepickerChange={this.handleYearData}
              viewType="verticle"
              isFilterButtonDisabled={ !email && !name && !phone }
            />
          </div> */}
          <div className="spacer"> </div>
          
        {show ? (
                    <AssingClass
                      show={show}
                      closeModal={closeModal}
                      assingClassRoom={assingClassRoom}
                      data={selectedStudentEvent}
                    />
                  ) : null}
          {pendingRegStudentsList.length > 0 ? (
            <>
            {/* <InfiniteScroll
              dataLength={pendingRegStudentsList.length}
              next={fetchMoreData}
              hasMore={pagination.totalPages === 1 ? false : hasMore}
              loader={<h4>Loading...</h4>}
              endMessage={
                <div className="alert alert-success text-center">
                  Yay! You have seen it all
                </div>
              }
            > */}
            {/* <DataTable header={headerList} data={pendingRegStudentsList} nestedHeader={nestedHeaders}/> */}
            <AgGridTable 
            rowData={pendingRegStudentsList} 
            columnDefs={columnDefs} 
            defaultColDef={{resizable: true,minWidth: 100}}
            frameworkComponents={{
                actionsListComponent
            }}
            pagination={pagination}
            isPaginationRequired={true}
            fetchParamsList={fetchParamsList}
            actionType={SET_REGISTRATION_PENDING_STUDENTS}
            setAgGridRef={setGridRefData}
              />
            {/* </InfiniteScroll> */}
            </>
          ): <div className="alert alert-success">
          No Data to view
        </div> }
         {/* {items.map((i, index) => (
            <div style={style} key={index}>
              div - #{index}
            </div>
          ))}
        </InfiniteScroll> */}
        </div>
      </PageLoader>
    </div>
  );
};

export default PendingRegistration;